import { optionalStringParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Schema } from "effect";
import { rootRedirectTargetByRole } from "@/lib/root-redirect-target";

const rootSearchSchema = parseableSearchSchema(
  Schema.Struct({
    error: optionalStringParam(),
  }),
);

export const Route = createFileRoute("/")({
  validateSearch: rootSearchSchema,
  beforeLoad: ({ context, search }) => {
    // 🔍 仅在服务器端执行重定向
    if (typeof window === "undefined") {
      if (context.auth.status === "account_pending") {
        throw redirect({ to: "/account-pending" });
      }
      if (context.auth.status === "authenticated") {
        const { user } = context.auth;
        const target = rootRedirectTargetByRole(user.role, user.studentId, user.staffId);
        throw redirect(target.kind === "external" ? { href: target.href } : { to: target.to });
      }
      if (context.auth.status === "anonymous") {
        throw redirect({
          to: "/login",
          ...(search.error && { search: { error: search.error } }),
        });
      }
      // Pending/Failed 留给客户端 auth 重试，避免基础设施故障误跳登录页。
    }

    // 🚀 客户端：由组件处理重定向
    // 原因：context.auth 是 pending 状态，会误判
  },
});
